  if (!customElements.get('media-gallery')) {
    customElements.define(
      'media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.init();
        }

        connectedCallback() {
          this.init(); // agar Shopify ne dobara render kiya ho
        }

        init() {
          if (this.__initialized) return; // ek hi baar bind karna
          this.__initialized = true;

          this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="GalleryViewer"]'),
            thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          };

          this.mql = window.matchMedia('(min-width: 750px)');
          if (!this.elements.thumbnails || !this.elements.viewer) return;

          // Slider event listener
          this.elements.viewer.addEventListener(
            'slideChanged',
            debounce(this.onSlideChanged.bind(this), 500)
          );

          // Thumbnail click binding
          this.elements.thumbnails.addEventListener('click', (e) => {
            const tile = e.target.closest('[data-target]');
            if (!tile) return;
            const id = tile.dataset.target;
            this._thumbClick = true;
            this.setActiveMedia(id, false);
            setTimeout(() => { this._thumbClick = false; }, 50);
          });

          // Desktop thumbnail layout accessibility fix
          if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches){
            this.removeListSemantic();
          }
        }

        get noAutoScroll() {
          return this.hasAttribute('data-no-autoscroll');
        }

        onSlideChanged(event) {
          const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
          this.setActiveThumbnail(thumbnail);
          this.setActiveMedia(event.detail.currentElement.dataset.mediaId,false);
        }

        setActiveMedia(mediaId, prepend) {
          
          //CWI CODE N
          let activeMedia;
          if(this.mql.matches && this.elements.viewer.querySelector('[data-media-id] img[alt*="1st-"]')){
            activeMedia = this.elements.viewer.querySelector('[data-media-id] img[alt*="1st-"]').closest('[data-media-id]');
          }else{
            activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');
          }
          
          if (!activeMedia) return;

          // Reset active
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));

          activeMedia.classList.add('is-active');

          if (prepend) {
            // First main image set
            if(this.elements.viewer.querySelector("img[alt*='1st-']")){
              const first_main_LI = this.elements.viewer.querySelector("img[alt*='1st-']").closest("li");
              const main_UL = first_main_LI.parentNode;
              main_UL.insertBefore(first_main_LI, main_UL.firstElementChild);
            }else{
              if (activeMedia.parentElement.firstChild !== activeMedia) {
                activeMedia.parentElement.prepend(activeMedia);
              }
            }
            
            if (this.elements.thumbnails) {
              //CWI CODE N
              let activeThumb;
              if(this.elements.thumbnails.querySelector(`[data-target] img[alt*="1st-"]`)){
                activeThumb = this.elements.thumbnails.querySelector(`[data-target] img[alt*="1st-"]`).closest(`[data-target]`);
              }else{
                activeThumb = this.elements.thumbnails.querySelector( `[data-target="${mediaId}"]`);
              }
              // First thumb image set
              if(this.elements.thumbnails.querySelector("img[alt*='1st-']")){
                const first_thumb_LI = this.elements.thumbnails.querySelector("img[alt*='1st-']").closest("li");
                const thumb_UL = first_thumb_LI.parentNode;
                thumb_UL.insertBefore(first_thumb_LI, thumb_UL.firstElementChild);
                setTimeout(() => {
                  first_thumb_LI.click();
                },10);
              }else{
                if (activeThumb && activeThumb.parentElement.firstChild !== activeThumb) {
                  activeThumb.parentElement.prepend(activeThumb);
                }
              }
            }
            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          }

          this.preventStickyHeader();

          window.setTimeout(() => {

            // ✅ Hamesha horizontal scroll viewer me
            if (!this.mql.matches || this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }

            // 🚫 Mobile me vertical page scroll mat karo
            if (!this.mql.matches || this.noAutoScroll) return;

            // ✅ Desktop only snap fix
            const rect = activeMedia.getBoundingClientRect();
            if (rect.top <= -0.5) {
              window.scrollTo({
                top: rect.top + window.scrollY,
                behavior: 'instant',
              });
            }
          });

          this.playActiveMedia(activeMedia);

          if (this.elements.thumbnails) {            
            //CWI CODE N
            let activeThumb;
            if(this.elements.thumbnails.querySelector(`[data-target="${mediaId}"] img[alt*="1st-"]`)){
              activeThumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"] img[alt*="1st-"]`).closest(`[data-target]`);
            }else{
              activeThumb = this.elements.thumbnails.querySelector( `[data-target="${mediaId}"]`);
            }
            
            if (activeThumb) {
              this.setActiveThumbnail(activeThumb);
              this.announceLiveRegion(
                activeMedia,
                activeThumb.dataset.mediaPosition
              );
            }
          }
        }

        setActiveThumbnail(thumbnail) {
          if (!this.elements.thumbnails || !thumbnail) return;

          this.elements.thumbnails.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
            
          const btn = thumbnail.querySelector('button');
          if (btn) btn.setAttribute('aria-current', true);

          if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }

        announceLiveRegion(activeItem, position) {
          const image = activeItem.querySelector(
            '.product__modal-opener--image img'
          );
          if (!image) return;

          image.onload = () => {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML =
              window.accessibilityStrings.imageAvailable.replace(
                '[index]',
                position
              );
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
          };

          // Force reload event
          image.src = image.src;
        }

        playActiveMedia(activeItem) {
          window.pauseAllMedia();
          const deferredMedia = activeItem.querySelector('.deferred-media');
          if (deferredMedia) deferredMedia.loadContent(false);

          if (this._thumbClick) return;
          const vimeoIframe = activeItem.querySelector('iframe[src*="vimeo.com"]');
          if (vimeoIframe) {
            let src = vimeoIframe.src;
            
            src = src
            .replace(/autoplay=\d/, "")
            .replace(/loop=\d/, "")
            .replace(/muted=\d/, "")
            .replace(/playsinline=\d/, "");
            
            const params = [
              "autoplay=1",
              "loop=1",
              "muted=1",
              "controls=1",
              "playsinline=1",
              "byline=0",
              "title=0",
            ];
            
            if (src.includes("?")) {
              src = src.split("?")[0] + "?" + params.join("&");
            } else {
              src = src + "?" + params.join("&");
            }
            
            vimeoIframe.src = src;
          }
        }

        preventStickyHeader() {
          this.stickyHeader =
            this.stickyHeader || document.querySelector('sticky-header');
          if (!this.stickyHeader) return;
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }

        removeListSemantic() {
          if (!this.elements.viewer.slider) return;
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          this.elements.viewer.sliderItems.forEach((slide) =>
            slide.setAttribute('role', 'presentation')
          );
        }
      }
    );
  }


// First thumb image set
// if(this.elements.thumbnails.querySelector("img[alt*='1st-']")){
//   const first_thumb_LI = this.elements.thumbnails.querySelector("img[alt*='1st-']").closest("li");
//   const thumb_UL = first_thumb_LI.parentNode;
//   thumb_UL.insertBefore(first_thumb_LI, thumb_UL.firstElementChild);
// }

// First main image set
// if(this.elements.viewer.querySelector("img[alt*='1st-']")){
//   const first_main_LI = this.elements.viewer.querySelector("img[alt*='1st-']").closest("li");
//   const main_UL = first_main_LI.parentNode;
//   main_UL.insertBefore(first_main_LI, main_UL.firstElementChild);
// }